import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createCaptureDL38299, getCaptureDL38299, updateCaptureDL38299 } from "../../api/captures/captureDL38299";
import { DL38299Form } from "../../types/forms/capture";

export const useCaptureDL38299 = (captureIdStr?: string) => {
  const queryClient = useQueryClient();
  const captureId = Number(captureIdStr);

  const queryKey = ["capture", captureId, "dl38299"];

  const result = useQuery({
    queryKey,
    queryFn: () => getCaptureDL38299(captureId),
    enabled: !!captureId,
  });

  const createMutation = useMutation({
    mutationFn: (values: DL38299Form) => createCaptureDL38299(captureId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ dlId, values }: { dlId: number; values: DL38299Form }) => updateCaptureDL38299(captureId, dlId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    DL38299Data: result.data ?? null,
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    createDL38299: createMutation.mutateAsync,
    updateDL38299: updateMutation.mutateAsync,
    isUpdating: createMutation.isPending || updateMutation.isPending,
  };
};
